// Product specifications mapping
// Base product specifications - organized by product family
export const BASE_PRODUCT_SPECS = {
	// Cloud Hosting Lite Series
	'Lite Starter': {
		'Site Hosted': 1,
		'Disk Space': '5GB',
		'Add On Domain': 0,
		'Park Domain': 0,
		'Sub Domain': 2,
		'Email Account': '5',
		'VCPU': '0.5',
		'RAM': '512 MB',
		'Inodes': '100,000'
	},
	'Lite 1': {
		'Site Hosted': 3,
		'Disk Space': '20 GB',
		'Add On Domain': 3,
		'Park Domain': 3,
		'Sub Domain': 5,
		'Email Account': '12',
		'VCPU': '1',
		'RAM': '2 GB',
		'Inodes': '150,000'
	},
	'Lite 2': {
		'Site Hosted': 5,
		'Disk Space': '40 GB',
		'Add On Domain': 6,
		'Park Domain': 6,
		'Sub Domain': 'Unlimited',
		'Email Account': 'Unlimited',
		'VCPU': '2',
		'RAM': '4 GB',
		'Inodes': '200,000'
	},
	'Lite 3': {
		'Site Hosted': 7,
		'Disk Space': '60 GB',
		'Add On Domain': 8,
		'Park Domain': 8,
		'Sub Domain': 'Unlimited',
		'Email Account': 'Unlimited',
		'VCPU': '3',
		'RAM': '6 GB',
		'Inodes': '250,000'
	},
	
	// Cloud Hosting Pro Series
	'Pro Starter': {
		'Site Hosted': 1,
		'Disk Space': '10 GB',
		'Add On Domain': 1,
		'Park Domain': 1,
		'Sub Domain': 5,
		'Email Account': 'Unlimited',
		'VCPU': '0.5',
		'RAM': '512MB',
		'Inodes': '150,000'
	},
	'Pro 1': {
		'Site Hosted': 3,
		'Disk Space': '20 GB',
		'Add On Domain': 3,
		'Park Domain': 3,
		'Sub Domain': 5,
		'Email Account': 'Unlimited',
		'VCPU': '1',
		'RAM': '2 GB',
		'Inodes': '150,000'
	},
	'Pro 2': {
		'Site Hosted': 5,
		'Disk Space': '40 GB',
		'Add On Domain': 6,
		'Park Domain': 6,
		'Sub Domain': 'Unlimited',
		'Email Account': 'Unlimited',
		'VCPU': '2',
		'RAM': '4 GB',
		'Inodes': '200,000'
	},
	'Pro 3': {
		'Site Hosted': 7,
		'Disk Space': '60 GB',
		'Add On Domain': 8,
		'Park Domain': 8,
		'Sub Domain': 'Unlimited',
		'Email Account': 'Unlimited',
		'VCPU': '3',
		'RAM': '6 GB',
		'Inodes': '250,000'
	},
	'Pro 4': {
		'Site Hosted': 7,
		'Disk Space': '100 GB',
		'Add On Domain': 8,
		'Park Domain': 8,
		'Sub Domain': 'Unlimited',
		'Email Account': 'Unlimited',
		'VCPU': '3',
		'RAM': '8 GB',
		'Inodes': '350,000'
	},
	
	// Cloud Hosting WordPress Series
	'WP 1': {
		'Site Hosted': 1,
		'Disk Space': '2 GB',
		'Add On Domain': 0,
		'Park Domain': 0,
		'Sub Domain': 0,
		'Email Account': 'Unlimited',
		'VCPU': '0.5',
		'RAM': '512 MB',
		'Inodes': '50,000'
	},
	'WP 2': {
		'Site Hosted': 2,
		'Disk Space': '5 GB',
		'Add On Domain': 1,
		'Park Domain': 1,
		'Sub Domain': 1,
		'Email Account': 'Unlimited',
		'VCPU': '1',
		'RAM': '1 GB',
		'Inodes': '50,000'
	},
	'WP 3': {
		'Site Hosted': 3,
		'Disk Space': '10 GB',
		'Add On Domain': 2,
		'Park Domain': 2,
		'Sub Domain': 1,
		'Email Account': 'Unlimited',
		'VCPU': '1.5',
		'RAM': '2 GB',
		'Inodes': '50,000'
	},
	'WP 4': {
		'Site Hosted': 4,
		'Disk Space': '20 GB',
		'Add On Domain': 3,
		'Park Domain': 3,
		'Sub Domain': 5,
		'Email Account': 'Unlimited',
		'VCPU': '1',
		'RAM': '2 GB',
		'Inodes': '150,000'
	},
	'WP 5': {
		'Site Hosted': 7,
		'Disk Space': '40 GB',
		'Add On Domain': 6,
		'Park Domain': 6,
		'Sub Domain': 'Unlimited',
		'Email Account': 'Unlimited',
		'VCPU': '2',
		'RAM': '4 GB',
		'Inodes': '200,000'
	},
	'WP 6': {
		'Site Hosted': 9,
		'Disk Space': '60 GB',
		'Add On Domain': 8,
		'Park Domain': 8,
		'Sub Domain': 'Unlimited',
		'Email Account': 'Unlimited',
		'VCPU': '3',
		'RAM': '6 GB',
		'Inodes': '250,000'
	},
	
	// Cloud Hosting MaxMail Series
	'Micro': {
		'Site Hosted': 3,
		'Disk Space': '20 GB',
		'Add On Domain': 3,
		'Park Domain': 3,
		'Sub Domain': 5,
		'Email Account': 'Unlimited',
		'VCPU': '1',
		'RAM': '2 GB',
		'Inodes': '150,000'
	},
	'Starter': {
		'Site Hosted': 3,
		'Disk Space': '20 GB',
		'Add On Domain': 3,
		'Park Domain': 3,
		'Sub Domain': 5,
		'Email Account': 'Unlimited',
		'VCPU': '1',
		'RAM': '2 GB',
		'Inodes': '150,000'
	},
	'Lite': {
		'Site Hosted': 3,
		'Disk Space': '20 GB',
		'Add On Domain': 3,
		'Park Domain': 3,
		'Sub Domain': 5,
		'Email Account': 'Unlimited',
		'VCPU': '1',
		'RAM': '2 GB',
		'Inodes': '150,000'
	},
	'SOHO': {
		'Site Hosted': 3,
		'Disk Space': '20 GB',
		'Add On Domain': 3,
		'Park Domain': 3,
		'Sub Domain': 5,
		'Email Account': 'Unlimited',
		'VCPU': '1',
		'RAM': '2 GB',
		'Inodes': '150,000'
	},
	
	// Cloud Hosting Proxima Series
	'Proxima 1': {
		'Site Hosted': 1,
		'Disk Space': '5 GB',
		'Add On Domain': 0,
		'Park Domain': 5,
		'Sub Domain': 5,
		'Email Account': '10',
		'VCPU': '0.5',
		'RAM': '512 MB',
		'Inodes': '100,000'
	},
	'Proxima 2': {
		'Site Hosted': 2,
		'Disk Space': '10 GB',
		'Add On Domain': 1,
		'Park Domain': 5,
		'Sub Domain': 10,
		'Email Account': 'Unlimited',
		'VCPU': '1',
		'RAM': '1 GB',
		'Inodes': '150,000'
	},
	'Proxima 3': {
		'Site Hosted': 5,
		'Disk Space': '25 GB',
		'Add On Domain': 4,
		'Park Domain': 10,
		'Sub Domain': 'Unlimited',
		'Email Account': 'Unlimited',
		'VCPU': '1',
		'RAM': '2 GB',
		'Inodes': '200,000'
	},
	'Proxima 4': {
		'Site Hosted': 10,
		'Disk Space': '50 GB',
		'Add On Domain': 5,
		'Park Domain': 20,
		'Sub Domain': 'Unlimited',
		'Email Account': 'Unlimited',
		'VCPU': '2',
		'RAM': '4 GB',
		'Inodes': '250,000'
	},
	'Proxima 5': {
		'Site Hosted': 12,
		'Disk Space': '75 GB',
		'Add On Domain': 6,
		'Park Domain': 30,
		'Sub Domain': 'Unlimited',
		'Email Account': 'Unlimited',
		'VCPU': '2',
		'RAM': '6 GB',
		'Inodes': '300,000'
	},
	'Proxima 6': {
		'Site Hosted': 14,
		'Disk Space': '100 GB',
		'Add On Domain': 7,
		'Park Domain': 40,
		'Sub Domain': 'Unlimited',
		'Email Account': 'Unlimited',
		'VCPU': '4',
		'RAM': '8 GB',
		'Inodes': '350,000'
	},
	
	// Cloud Hosting Core (Hyper Quantum) Series
	'Core 1': {
		'Site Hosted': 10,
		'Disk Space': '100 GB',
		'Add On Domain': 9,
		'Park Domain': 10,
		'Sub Domain': 0,
		'Email Account': 'Unlimited',
		'VCPU': '2',
		'RAM': '4 GB',
		'Inodes': 'Unlimited'
	},
	'Core 2': {
		'Site Hosted': 25,
		'Disk Space': '200 GB',
		'Add On Domain': 9,
		'Park Domain': 10,
		'Sub Domain': 0,
		'Email Account': 'Unlimited',
		'VCPU': '4',
		'RAM': '8 GB',
		'Inodes': 'Unlimited'
	},
	'Core 3': {
		'Site Hosted': 50,
		'Disk Space': '300 GB',
		'Add On Domain': 49,
		'Park Domain': 50,
		'Sub Domain': 9,
		'Email Account': 'Unlimited',
		'VCPU': '6',
		'RAM': '12 GB',
		'Inodes': 'Unlimited'
	},
	'Core 4': {
		'Site Hosted': 100,
		'Disk Space': '400 GB',
		'Add On Domain': 99,
		'Park Domain': 100,
		'Sub Domain': 99,
		'Email Account': 'Unlimited',
		'VCPU': '8',
		'RAM': '16 GB',
		'Inodes': 'Unlimited'
	},

	// Enterprise Series
	'Enterprise 1': {
		'Site Hosted': 'Unlimited',
		'Disk Space': '60 GB',
		'Add On Domain': 'Unlimited',
		'Park Domain': 'Unlimited',
		'Sub Domain': 'Unlimited',
		'Email Account': 'Unlimited',
		'VCPU': '2',
		'RAM': '4 GB',
		'Inodes': 'Unlimited'
	},
	'Enterprise 2': {
		'Site Hosted': 'Unlimited',
		'Disk Space': '140 GB',
		'Add On Domain': 'Unlimited',
		'Park Domain': 'Unlimited',
		'Sub Domain': 'Unlimited',
		'Email Account': 'Unlimited',
		'VCPU': '4',
		'RAM': '8 GB',
		'Inodes': 'Unlimited'
	},
	'Enterprise 3': {
		'Site Hosted': 'Unlimited',
		'Disk Space': '300 GB',
		'Add On Domain': 'Unlimited',
		'Park Domain': 'Unlimited',
		'Sub Domain': 'Unlimited',
		'Email Account': 'Unlimited',
		'VCPU': '6',
		'RAM': '16 GB',
		'Inodes': 'Unlimited'
	},
	'Enterprise 1 DA': {
		'Site Hosted': 'Unlimited',
		'Disk Space': '60 GB',
		'Add On Domain': 'Unlimited',
		'Park Domain': 'Unlimited',
		'Sub Domain': 'Unlimited',
		'Email Account': 'Unlimited',
		'VCPU': '2',
		'RAM': '4 GB',
		'Inodes': 'Unlimited'
	},
	'Enterprise 2 DirectAdmin': {
		'Site Hosted': 'Unlimited',
		'Disk Space': '140 GB',
		'Add On Domain': 'Unlimited',
		'Park Domain': 'Unlimited',
		'Sub Domain': 'Unlimited',
		'Email Account': 'Unlimited',
		'VCPU': '4',
		'RAM': '8 GB',
		'Inodes': 'Unlimited'
	},

	// Flex WP Series
	'Flex WP 1': {
		'Site Hosted': 1,
		'Disk Space': '10 GB',
		'Add On Domain': 0,
		'Park Domain': 0,
		'Sub Domain': 0,
		'Email Account': 0,
		'VCPU': '1',
		'RAM': '1 GB',
		'Inodes': 'Fair Usage'
	},
	'Flex WP 2': {
		'Site Hosted': 1,
		'Disk Space': '20 GB',
		'Add On Domain': 0,
		'Park Domain': 0,
		'Sub Domain': 0,
		'Email Account': 0,
		'VCPU': '2',
		'RAM': '2 GB',
		'Inodes': 'Fair Usage'
	},
	
	// Private Label Reseller Series (Different fields: Akun Hosting, Disk Space, Bandwidth)
	'PVTR-A': {
		'Akun Hosting': '10 Akun',
		'Disk Space': '10 GB',
		'Bandwidth': '500 GB'
	},
	'PVTR-B': {
		'Akun Hosting': '20 Akun',
		'Disk Space': '20 GB',
		'Bandwidth': '800 GB'
	},
	'PVTR-C': {
		'Akun Hosting': '50 Akun',
		'Disk Space': '50 GB',
		'Bandwidth': '1,500 GB'
	},
	
	// Cloud VPS KVM Series (Common: Bandwidth Unmetered, IPv4/IPv6, Uplink, TUN/TAP, Server Location Indonesia)
	// Only different fields: RAID SSD, RAM, CPU Core
	'Cloud VPS KVM SC1': {
		'RAID SSD': '25GB',
		'RAM': '1GB',
		'CPU Core': '1 Core'
	},
	'Cloud VPS KVM SC2': {
		'RAID SSD': '50GB',
		'RAM': '2GB',
		'CPU Core': '1 Core'
	},
	'Cloud VPS KVM SC4': {
		'RAID SSD': '80GB',
		'RAM': '4GB',
		'CPU Core': '2 Core'
	},
	'Cloud VPS KVM SC8': {
		'RAID SSD': '160GB',
		'RAM': '8GB',
		'CPU Core': '4 Core'
	},
	'Cloud VPS KVM SC16': {
		'RAID SSD': '320GB',
		'RAM': '16GB',
		'CPU Core': '6 Core'
	},
	'Cloud VPS KVM SC32': {
		'RAID SSD': '640GB',
		'RAM': '32GB',
		'CPU Core': '8 Core'
	},
	'Cloud VPS KVM SC64': {
		'RAID SSD': '1,280GB',
		'RAM': '64GB',
		'CPU Core': '16 Core'
	},
	'Cloud VPS KVM NANO SC': {
		'RAID SSD': '15GB',
		'RAM': '0.5GB',
		'CPU Core': '1 Core'
	},
	
	// Cloud VPS Moodle Series (Common: Bandwidth Unmetered, IPv4/IPv6, Uplink, TUN/TAP, Server Location Indonesia)
	// Only different fields: RAID SSD, RAM, CPU Core
	'Cloud VPS Moodle SC2': {
		'RAID SSD': '50 GB',
		'RAM': '2 GB',
		'CPU Core': '1 Core'
	},
	'Cloud VPS Moodle SC4': {
		'RAID SSD': '80 GB',
		'RAM': '4 GB',
		'CPU Core': '2 Core'
	},
	'Cloud VPS Moodle SC8': {
		'RAID SSD': '160 GB',
		'RAM': '8 GB',
		'CPU Core': '4 Core'
	},
	'Cloud VPS Moodle SC16': {
		'RAID SSD': '320 GB',
		'RAM': '16 GB',
		'CPU Core': '6 Core'
	},
	'Cloud VPS Moodle SC32': {
		'RAID SSD': '640 GB',
		'RAM': '32 GB',
		'CPU Core': '8 Core'
	},
	'Cloud VPS Moodle SC64': {
		'RAID SSD': '1,280 GB',
		'RAM': '64 GB',
		'CPU Core': '16 Core'
	},
	
	// HC (High Compute) Series (Common: RAID SSD 60 GB, Bandwidth Unmetered, Server Location Indonesia)
	// Only different fields: RAM, CPU Core (all have same disk)
	'HC 4': {
		'RAID SSD': '60 GB',
		'RAM': '4 GB',
		'CPU Core': '4 Core'
	},
	'HC 8': {
		'RAID SSD': '60 GB',
		'RAM': '8 GB',
		'CPU Core': '4 Core'
	},
	'HC 16': {
		'RAID SSD': '60 GB',
		'RAM': '16 GB',
		'CPU Core': '8 Core'
	},
	'HC 24': {
		'RAID SSD': '60 GB',
		'RAM': '24 GB',
		'CPU Core': '12 Core'
	},
	
	// NANO SC
	'NANO SC': {
		'RAID SSD': '160GB',
		'RAM': '8GB',
		'CPU Core': '4 Core'
	},
	
	// SSL Products (Fields: Jenis Validasi, Domain Type, Garansi)
	'AlphaSSL by Globalsign': {
		'Jenis Validasi': 'Domain Validation',
		'Domain Type': 'Single (includes www)',
		'Garansi': 'US$ 10,000',
		'Wildcard': false
	},
	'AlphaSSL by Globalsign Wildcard': {
		'Jenis Validasi': 'Domain Validation',
		'Domain Type': 'Wildcard',
		'Garansi': 'US$ 10,000',
		'Wildcard': true
	},
	'GlobalSign Extended Validate SSL Greenbar': {
		'Jenis Validasi': 'Extended Validation',
		'Domain Type': 'Single (includes www)',
		'Garansi': 'US$ 1,500,000',
		'Wildcard': false
	},
	'Globalsign OrganizationSSL': {
		'Jenis Validasi': 'Organization Validation',
		'Domain Type': 'Single (includes www)',
		'Garansi': 'US$ 1,250,000',
		'Wildcard': false
	},
	'Globalsign OrganizationSSL Wildcard': {
		'Jenis Validasi': 'Organization Validation',
		'Domain Type': 'Wildcard',
		'Garansi': 'US$ 1,250,000',
		'Wildcard': true
	},
	'Sectigo InstantSSL': {
		'Jenis Validasi': 'Organization Validation',
		'Domain Type': 'Single (includes www)',
		'Garansi': 'US$ 50,000',
		'Wildcard': false
	},
	'Sectigo Premium SSL': {
		'Jenis Validasi': 'Organization Validation',
		'Domain Type': 'Wildcard',
		'Garansi': 'US$ 50,000',
		'Wildcard': true
	},
	'Sectigo Positive SSL': {
		'Jenis Validasi': 'Domain Validation',
		'Domain Type': 'Single (includes www)',
		'Garansi': 'US$ 10,000',
		'Wildcard': false
	},
	'Sectigo Positive SSL Wildcard': {
		'Jenis Validasi': 'Domain Validation',
		'Domain Type': 'Wildcard',
		'Garansi': 'US$ 10,000',
		'Wildcard': true
	},
	'Sectigo EV SSL': {
		'Jenis Validasi': 'Extended Validation',
		'Domain Type': 'Single (includes www)',
		'Garansi': 'US$ 1,000,000',
		'Wildcard': false
	},
	
	// Email Suite Products (Fields: Storage, Google Meet Participants, Video Conference Recording, Video Conference Attendance, G Vault)
	'Business Starter': {
		'Storage': '30 GB',
		'Google Meet': '100 Participants',
		'Video Conference Recording': false,
		'Video Conference Attendance': false,
		'G Vault': false
	},
	'Business Standard': {
		'Storage': '2 TB',
		'Google Meet': '150 Participants',
		'Video Conference Recording': true,
		'Video Conference Attendance': false,
		'G Vault': false
	},
	'Business Plus': {
		'Storage': '5 TB',
		'Google Meet': '250 Participants',
		'Video Conference Recording': true,
		'Video Conference Attendance': true,
		'G Vault': true
	},
	'Microsoft 365 Business Basic': {
		'Storage': '1 TB Cloud Storage',
		'Email Capacity': '50 GB mailbox',
		'Platform': 'Online Version of Office Applications',
		'Video Conference': 'HD via Microsoft Teams'
	},
	'Microsoft 365 App': {
		'Storage': '1 TB Cloud Storage',
		'Email Capacity': 'Email account not included',
		'Platform': 'Desktop Applications 2016 for PC/MAC (up to 5 devices)'
	},
	'Microsoft 365 Business Standard': {
		'Storage': '1 TB Cloud Storage',
		'Email Capacity': '50 GB mailbox',
		'Platform': 'Desktop & Online Applications',
		'Video Conference': 'HD via Microsoft Teams'
	},
	'ECCS Basic': {
		'Email': 'Public Cloud Email',
		'Storage': '25 GB',
		'Account': '1,000 Akun Kontak',
		'Max File Upload': '20 MB'
	},
	'ECCS Basic 10 Seat': {
		'Email': 'Public Cloud Email',
		'Storage': '25 GB',
		'Account': '1,000 Akun Kontak',
		'Max File Upload': '20 MB',
		'Seats': '10'
	},
	'ECCS Basic 15 Seat': {
		'Email': 'Public Cloud Email',
		'Storage': '25 GB',
		'Account': '1,000 Akun Kontak',
		'Max File Upload': '20 MB',
		'Seats': '15'
	},
	'ECCS Basic 50 Seat': {
		'Email': 'Public Cloud Email',
		'Storage': '25 GB',
		'Account': '1,000 Akun Kontak',
		'Max File Upload': '20 MB',
		'Seats': '50'
	},
	'ECCS Basic 100 Seat': {
		'Email': 'Public Cloud Email',
		'Storage': '25 GB',
		'Account': '1,000 Akun Kontak',
		'Max File Upload': '20 MB',
		'Seats': '100'
	},
	'ECCS Basic 500 Seat': {
		'Email': 'Public Cloud Email',
		'Storage': '25 GB',
		'Account': '1,000 Akun Kontak',
		'Max File Upload': '20 MB',
		'Seats': '500'
	},
	'ECCS Basic 1000 Seat': {
		'Email': 'Public Cloud Email',
		'Storage': '25 GB',
		'Account': '1,000 Akun Kontak',
		'Max File Upload': '20 MB',
		'Seats': '1000'
	},
	'Titan Pro': {
		'Capacity': '10 GB/Mailbox',
		'Email Rate': '200 Emails/Hour, 500 Emails/day',
		'Email Templates': '3',
		'Contact Group': '1',
		'2FA': false
	},
	'Titan Premium': {
		'Capacity': '50 GB/Mailbox',
		'Email Rate': '300 Emails/Hour, 1000 Emails/day',
		'Email Templates': 'Unlimited',
		'Contact Group': 'Unlimited',
		'2FA': true
	},
	
	// Digital Signature Products
	'Digital Signature Unlimited': {
		'Type': 'Digital Signature',
		'Includes': 'Ongkos kirim seluruh Indonesia + Manual instalasi',
		'Garansi': '6 Bulan (Dongle)',
		'Replacement Cost': 'Rp1,500,000'
	},
	
	// Diego VPN Products (Fields: Bandwidth, Users, Dedicated IP, Dedicated Node)
	'Diego VPN Lite': {
		'Bandwidth': '40GB',
		'VPN': 'VPN Indonesia',
		'Users': 'Single User',
		'Dedicated IP': false,
		'Dedicated Node': false
	},
	'Diego VPN Unlimited': {
		'Bandwidth': 'Unlimited',
		'VPN': 'VPN Indonesia',
		'Users': 'Single User',
		'Dedicated IP': 'Optional',
		'Dedicated Node': false
	},
	'Diego VPN Corporate': {
		'Bandwidth': 'Unlimited',
		'VPN': 'VPN Indonesia',
		'Users': '2 Users',
		'Dedicated IP': true,
		'Dedicated Node': true
	},
	
	// Extended Support Products
	'Extended Support (1 Point)': {
		'Topup Point Support': '1'
	},
	'Extended Support (3 Point)': {
		'Topup Point Support': '3'
	},
	'Extended Support (10 Point)': {
		'Topup Point Support': '10'
	},
	'Extended Support (20 Point)': {
		'Topup Point Support': '20'
	},
};

// Add-on configurations
export const ADDON_CONFIGS = {
	'Velocity': {
		displayName: '+ Velocity',
		description: 'Enhanced performance optimization',
		// Velocity doesn't change base specs, just adds performance features
	},
	'Backup Harian': {
		displayName: '+ Backup Harian',
		description: 'Daily backup service',
		// Backup Harian is a service add-on, specs remain the same
	}
};

// Server locations - based on actual server options
export const SERVER_LOCATIONS = [
	'SouthJKT-1',
	'SouthJKT-2', 
	'WestJavaBDG-1',
	'SGP-1',
	'Singapura',
	'USA'
];

// Function to generate product name with addons and location
export const generateProductName = (baseProduct, addons = [], location = '') => {
	let productName = baseProduct;
	
	// Add addons
	addons.forEach(addon => {
		if (ADDON_CONFIGS[addon]) {
			productName += ` ${ADDON_CONFIGS[addon].displayName}`;
		}
	});
	
	// Add location
	if (location) {
		productName += ` (${location})`;
	}
	
	return productName;
};

// Function to get product specifications (base specs + addon effects)
export const getProductSpecs = (baseProduct, addons = []) => {
	const baseSpecs = BASE_PRODUCT_SPECS[baseProduct];
	if (!baseSpecs) return null;
	
	// Clone base specs
	const specs = { ...baseSpecs };
	
	// Apply addon modifications if any
	addons.forEach(addon => {
		// For now, addons don't modify specs, but this structure allows for future expansion
		if (ADDON_CONFIGS[addon] && ADDON_CONFIGS[addon].specModifications) {
			Object.assign(specs, ADDON_CONFIGS[addon].specModifications);
		}
	});
	
	return specs;
};

// Legacy compatibility - generate all product combinations
export const PRODUCT_SPECIFICATIONS = (() => {
	const allProducts = {};
	
	// Add base products
	Object.keys(BASE_PRODUCT_SPECS).forEach(baseProduct => {
		allProducts[baseProduct] = BASE_PRODUCT_SPECS[baseProduct];
		
		// Add "Cloud Hosting" prefix for display compatibility (hanya untuk hosting products)
		// Exclude VPS, PVTR, SSL, Email Suite, Digital Signature, Diego VPN, Extended Support products
		if (!baseProduct.includes('VPS') && 
		    !baseProduct.includes('PVTR') && 
		    !baseProduct.includes('HC ') &&
		    !baseProduct.includes('NANO SC') &&
		    !baseProduct.includes('SSL') &&
		    !baseProduct.includes('Sectigo') &&
		    !baseProduct.includes('AlphaSSL') &&
		    !baseProduct.includes('Globalsign') &&
		    !baseProduct.includes('GlobalSign') &&
		    !baseProduct.includes('Business') &&
		    !baseProduct.includes('Microsoft 365') &&
		    !baseProduct.includes('ECCS') &&
		    !baseProduct.includes('Titan') &&
		    !baseProduct.includes('Digital Signature') &&
		    !baseProduct.includes('Diego VPN') &&
		    !baseProduct.includes('Extended Support')) {
			const cloudHostingName = `Cloud Hosting ${baseProduct}`;
			allProducts[cloudHostingName] = BASE_PRODUCT_SPECS[baseProduct];
			
			// Determine if product supports Velocity and Backup Harian
			const isProxima = baseProduct.includes('Proxima');
			const isCore = baseProduct.includes('Core') || baseProduct.includes('Hyper Quantum');
			const isMaxMail = baseProduct.includes('Micro') || baseProduct.includes('Starter') || 
			                  baseProduct.includes('Lite') || baseProduct.includes('SOHO');
			
			const supportsVelocity = isProxima || isCore;
			const supportsBackup = isMaxMail || isProxima || isCore;
			
			// Add Velocity variants (for Proxima and Core series)
			if (supportsVelocity) {
			const velocityProduct = generateProductName(baseProduct, ['Velocity']);
			allProducts[velocityProduct] = getProductSpecs(baseProduct, ['Velocity']);
				
				const cloudVelocityProduct = generateProductName(cloudHostingName, ['Velocity']);
				allProducts[cloudVelocityProduct] = getProductSpecs(baseProduct, ['Velocity']);
			}
			
			// Add Backup Harian variants (for MaxMail, Proxima, and Core series)
			if (supportsBackup && !baseProduct.includes('Enterprise') && !baseProduct.includes('NANO')) {
			const backupProduct = generateProductName(baseProduct, ['Backup Harian']);
			allProducts[backupProduct] = getProductSpecs(baseProduct, ['Backup Harian']);
				
				const cloudBackupProduct = generateProductName(cloudHostingName, ['Backup Harian']);
				allProducts[cloudBackupProduct] = getProductSpecs(baseProduct, ['Backup Harian']);
				
				// Add combined Velocity + Backup Harian variants (only for products that support both)
				if (supportsVelocity) {
					const combinedProduct = generateProductName(baseProduct, ['Velocity', 'Backup Harian']);
					allProducts[combinedProduct] = getProductSpecs(baseProduct, ['Velocity', 'Backup Harian']);
					
					const cloudCombinedProduct = generateProductName(cloudHostingName, ['Velocity', 'Backup Harian']);
					allProducts[cloudCombinedProduct] = getProductSpecs(baseProduct, ['Velocity', 'Backup Harian']);
				}
			}
		}
	});
	
	// Note: All products use appropriate field structures:
	// - Hosting products: Site Hosted, Disk Space, Add On Domain, Park Domain, Sub Domain, Email Account, VCPU, RAM, Inodes
	// - VPS products (KVM, Moodle, HC, NANO): RAID SSD, RAM, CPU Core
	// - PVTR products: Akun Hosting, Disk Space, Bandwidth
	// - SSL products: Jenis Validasi, Domain Type, Garansi, Wildcard
	// - Email Suite (Google Workspace): Storage, Google Meet, Video Conference Recording, Video Conference Attendance, G Vault
	// - Email Suite (Microsoft 365): Storage, Email Capacity, Platform, Video Conference
	// - Email Suite (ECCS): Email, Storage, Account, Max File Upload, Seats
	// - Email Suite (Titan): Capacity, Email Rate, Email Templates, Contact Group, 2FA
	// - Digital Signature: Type, Includes, Garansi, Replacement Cost
	// - Diego VPN: Bandwidth, VPN, Users, Dedicated IP, Dedicated Node
	// - Extended Support: Topup Point Support
	
	return allProducts;
})();

// Helper function to get product specifications
export const getProductSpecifications = (productName) => {
	return PRODUCT_SPECIFICATIONS[productName] || null;
};

/**
 * Helper function to get base product name (removes addons and location)
 * 
 * Examples:
 * - "Cloud Hosting Proxima 1 + Velocity" -> "Proxima 1"
 * - "Cloud Hosting Core 1 + Backup Harian" -> "Core 1"
 * - "Cloud Hosting Proxima 2 + Velocity + Backup Harian" -> "Proxima 2"
 * - "Micro (SouthJKT-1)" -> "Micro"
 * - "Cloud Hosting Core 1 + Backup Harian + Velocity (WestJavaBDG-1)" -> "Core 1"
 * 
 * @param {string} productName - Full product name with addons and location
 * @returns {string} - Base product name without addons and location
 */
export const getBaseProductName = (productName) => {
	if (!productName) return '';
	
	// Remove location suffix (e.g., " (SouthJKT-2)", " (WestJavaBDG-1)")
	let baseName = productName.replace(/\s*\([^)]+\)$/, '');
	
	// Remove addon suffixes in any order (handle combinations)
	// Remove "+ Velocity + Backup Harian" or "+ Backup Harian + Velocity" (if combined)
	baseName = baseName.replace(/\s*\+\s*Velocity\s*\+\s*Backup\s+Harian\s*$/i, '');
	baseName = baseName.replace(/\s*\+\s*Backup\s+Harian\s*\+\s*Velocity\s*$/i, '');
	// Remove individual addons
	baseName = baseName.replace(/\s*\+\s*Velocity\s*$/i, '');
	baseName = baseName.replace(/\s*\+\s*Backup\s+Harian\s*$/i, '');
	
	// Remove "Cloud Hosting" prefix if exists
	baseName = baseName.replace(/^Cloud Hosting\s+/i, '');
	
	// Trim any extra whitespace
	return baseName.trim();
};

/**
 * Helper function to extract addons from product name
 * 
 * Examples:
 * - "Cloud Hosting Proxima 1 + Velocity" -> ['Velocity']
 * - "Cloud Hosting Core 1 + Backup Harian" -> ['Backup Harian']
 * - "Cloud Hosting Proxima 2 + Velocity + Backup Harian" -> ['Velocity', 'Backup Harian']
 * - "Micro" -> []
 * 
 * @param {string} productName - Full product name
 * @returns {Array<string>} - Array of addon names found in the product name
 */
export const getProductAddons = (productName) => {
	const addons = [];
	
	if (productName.includes('+ Velocity')) {
		addons.push('Velocity');
	}
	if (productName.includes('+ Backup Harian')) {
		addons.push('Backup Harian');
	}
	
	return addons;
};

// Helper function to extract location from product name
export const getProductLocation = (productName) => {
	const locationMatch = productName.match(/\(([^)]+)\)$/);
	return locationMatch ? locationMatch[1] : '';
};

// Helper function to get all variants of a base product
export const getProductVariants = (baseProductName) => {
	const variants = [];
	
	// Check if it's a base product that can have variants
	if (baseProductName.includes('Proxima') || 
		baseProductName.includes('Core') ||
		baseProductName.includes('Lite') ||
		baseProductName.includes('Pro') ||
		baseProductName.includes('WP') ||
		baseProductName.includes('Micro') ||
		baseProductName.includes('Starter') ||
		baseProductName.includes('SOHO') ||
		baseProductName.includes('Flex')) {
		
		// Add base product
		variants.push({
			name: baseProductName,
			addons: [],
			location: '',
			specs: BASE_PRODUCT_SPECS[baseProductName]
		});
		
		// Add Velocity variants for Proxima and Core
		if (baseProductName.includes('Proxima') || baseProductName.includes('Core')) {
			variants.push({
				name: generateProductName(baseProductName, ['Velocity']),
				addons: ['Velocity'],
				location: '',
				specs: getProductSpecs(baseProductName, ['Velocity'])
			});
		}
		
		// Add Backup Harian variants for most hosting products
		if (!baseProductName.includes('Enterprise') && !baseProductName.includes('NANO')) {
			variants.push({
				name: generateProductName(baseProductName, ['Backup Harian']),
				addons: ['Backup Harian'],
				location: '',
				specs: getProductSpecs(baseProductName, ['Backup Harian'])
			});
		}
	}
	
	return variants;
};

// Helper function to compare products efficiently
export const compareProducts = (product1, product2) => {
	const base1 = getBaseProductName(product1);
	const base2 = getBaseProductName(product2);
	
	// If same base product, just compare addons and location
	if (base1 === base2) {
		const addons1 = getProductAddons(product1);
		const addons2 = getProductAddons(product2);
		const location1 = getProductLocation(product1);
		const location2 = getProductLocation(product2);
		
		return {
			sameBase: true,
			baseProduct: base1,
			baseSpecs: BASE_PRODUCT_SPECS[base1],
			differences: {
				addons: { product1: addons1, product2: addons2 },
				location: { product1: location1, product2: location2 }
			},
			// Add specs for comparison display
			specs: { 
				product1: getProductSpecs(base1, addons1), 
				product2: getProductSpecs(base2, addons2) 
			}
		};
	}
	
	// Different base products - compare specs
	const specs1 = getProductSpecifications(product1);
	const specs2 = getProductSpecifications(product2);
	
	return {
		sameBase: false,
		baseProduct: { product1: base1, product2: base2 },
		baseSpecs: { product1: BASE_PRODUCT_SPECS[base1], product2: BASE_PRODUCT_SPECS[base2] },
		specs: { product1: specs1, product2: specs2 }
	};
};

// Helper function to check if two products can be compared (same base specs)
export const canCompareProducts = (product1, product2) => {
	const base1 = getBaseProductName(product1);
	const base2 = getBaseProductName(product2);
	
	// Can compare if same base product
	return base1 === base2;
};

// Helper function to get comparison message for same base products
export const getSameBaseComparisonMessage = (product1, product2) => {
	const addons1 = getProductAddons(product1);
	const addons2 = getProductAddons(product2);
	const location1 = getProductLocation(product1);
	const location2 = getProductLocation(product2);
	
	const messages = [];
	
	// Check addon differences
	if (JSON.stringify(addons1) !== JSON.stringify(addons2)) {
		messages.push(`Addon berbeda: ${addons1.join(', ') || 'Tidak ada'} vs ${addons2.join(', ') || 'Tidak ada'}`);
	}
	
	// Check location differences
	if (location1 !== location2) {
		messages.push(`Lokasi server berbeda: ${location1 || 'Default'} vs ${location2 || 'Default'}`);
	}
	
	// If no differences, they are identical
	if (messages.length === 0) {
		return "Produk identik - spesifikasi sama persis";
	}
	
	return messages.join('; ');
};

// Helper function to compare specifications
// Helper function to normalize storage/memory units to MB for comparison
const normalizeToMB = (value) => {
	if (typeof value === 'number') return value;
	if (!value || typeof value !== 'string') return 0;
	
	const str = value.toString().toUpperCase().trim();
	const num = parseFloat(str);
	
	if (isNaN(num)) return 0;
	
	// Check for unit
	if (str.includes('TB')) {
		return num * 1024 * 1024; // TB to MB
	} else if (str.includes('GB')) {
		return num * 1024; // GB to MB
	} else if (str.includes('MB')) {
		return num; // Already in MB
	} else if (str.includes('KB')) {
		return num / 1024; // KB to MB
	}
	
	// If no unit specified, return as is
	return num;
};

export const compareSpecifications = (currentSpecs, newSpecs) => {
	// Always show comparison if newSpecs exists, even if currentSpecs is null
	if (!newSpecs) return null;

	const comparison = {};
	
	// If currentSpecs is not available, use "Unknown (Old Package)" for all specs
	const fallbackCurrentSpecs = currentSpecs || {};
	const allKeys = Object.keys(newSpecs);

	allKeys.forEach(key => {
		const currentValue = fallbackCurrentSpecs[key] || '-';
		const newValue = newSpecs[key];

		// If current value is "-", always show as same (with equals icon)
		if (currentValue === '-') {
			comparison[key] = { type: 'same', current: currentValue, new: newValue };
		} else if (currentValue === newValue) {
			comparison[key] = { type: 'same', current: currentValue, new: newValue };
		} else if (typeof currentValue === 'number' && typeof newValue === 'number') {
			comparison[key] = {
				type: newValue > currentValue ? 'upgrade' : 'downgrade',
				current: currentValue,
				new: newValue
			};
		} else if (currentValue === 'Unlimited' && newValue !== 'Unlimited') {
			comparison[key] = { type: 'downgrade', current: currentValue, new: newValue };
		} else if (currentValue !== 'Unlimited' && newValue === 'Unlimited') {
			comparison[key] = { type: 'upgrade', current: currentValue, new: newValue };
		} else {
			// For string comparisons, check if it's storage/memory related
			const isStorageOrMemory = key === 'RAM' || key === 'Disk Space' || 
			                          key === 'RAID SSD' || key.includes('Storage') || 
			                          key.includes('Memory');
			
			if (isStorageOrMemory) {
				// Normalize to MB for proper comparison
				const currentMB = normalizeToMB(currentValue);
				const newMB = normalizeToMB(newValue);
				
				if (currentMB > 0 && newMB > 0) {
					comparison[key] = {
						type: newMB > currentMB ? 'upgrade' : (newMB < currentMB ? 'downgrade' : 'same'),
						current: currentValue,
						new: newValue
					};
				} else {
					// Fallback to string comparison
			const currentNum = parseFloat(currentValue);
			const newNum = parseFloat(newValue);

			if (!isNaN(currentNum) && !isNaN(newNum)) {
				comparison[key] = {
					type: newNum > currentNum ? 'upgrade' : 'downgrade',
					current: currentValue,
					new: newValue
				};
			} else {
				comparison[key] = { type: 'different', current: currentValue, new: newValue };
					}
				}
			} else {
				// For non-storage fields, try to extract numbers
				const currentNum = parseFloat(currentValue);
				const newNum = parseFloat(newValue);

				if (!isNaN(currentNum) && !isNaN(newNum)) {
					comparison[key] = {
						type: newNum > currentNum ? 'upgrade' : 'downgrade',
						current: currentValue,
						new: newValue
					};
				} else {
					comparison[key] = { type: 'different', current: currentValue, new: newValue };
				}
			}
		}
	});

	return comparison;
};
